// Translations for the "My other accounts" (linked accounts) section
// across the 13 supported languages.
import { useLanguage } from '../context/LanguageContext';

export const linkedAccountsI18n = {
  fr: {
    title: 'Mes autres comptes',
    empty: "Vous n'avez aucun autre compte lié. Vous pouvez lier UN compte {kind} pour basculer facilement entre vos comptes.",
    addBtn: 'Ajouter un compte {kind}',
    switching: 'Chargement…',
    loading: 'Chargement…',
    removeConfirm: 'Retirer le compte « {name} » de vos autres comptes ?',
    removed: 'Compte retiré',
    switched: 'Compte actif : {name}',
    switchError: 'Erreur lors du changement de compte',
    modalTitle: 'Ajouter un compte {kind}',
    step1Hint: 'Connectez-vous avec les identifiants du compte {kind} que vous souhaitez lier. Un code de confirmation sera envoyé à son adresse email.',
    email: 'Email',
    password: 'Mot de passe',
    captchaLabel: 'Calcul anti-robot :',
    captchaHint: '= ?',
    sendCode: 'Envoyer le code',
    codeSent: 'Code envoyé à {email}',
    otpHint: "Un code à 6 chiffres a été envoyé à {email}. Saisissez-le pour valider la liaison.",
    codeLabel: 'Code à 6 chiffres',
    linkBtn: 'Lier le compte',
    back: '← Revenir à l\'étape précédente',
    ok: 'Compte lié avec succès !',
    footNote: 'Chaque liaison exige les identifiants du compte cible + un code envoyé par email. Vous pouvez toujours retirer un compte lié à tout moment.',
    close: 'Fermer',
  },
  en: {
    title: 'My other accounts',
    empty: "You have no other linked account. You can link ONE {kind} account to switch between them.",
    addBtn: 'Add a {kind} account',
    switching: 'Loading…',
    loading: 'Loading…',
    removeConfirm: 'Remove the account "{name}" from your other accounts?',
    removed: 'Account removed',
    switched: 'Now signed in as: {name}',
    switchError: 'Error switching account',
    modalTitle: 'Add a {kind} account',
    step1Hint: 'Sign in with the credentials of the {kind} account you want to link. A confirmation code will be sent to its email.',
    email: 'Email',
    password: 'Password',
    captchaLabel: 'Anti-robot check:',
    captchaHint: '= ?',
    sendCode: 'Send code',
    codeSent: 'Code sent to {email}',
    otpHint: "A 6-digit code was sent to {email}. Enter it to confirm the link.",
    codeLabel: '6-digit code',
    linkBtn: 'Link account',
    back: '← Back to previous step',
    ok: 'Account linked successfully!',
    footNote: 'Every link requires the target account credentials + a code sent by email. You can always remove a linked account at any time.',
    close: 'Close',
  },
  es: {
    title: 'Mis otras cuentas',
    empty: "No tienes ninguna otra cuenta vinculada. Puedes vincular UNA cuenta {kind} para cambiar entre ellas.",
    addBtn: 'Añadir una cuenta {kind}',
    switching: 'Cargando…',
    loading: 'Cargando…',
    removeConfirm: '¿Quitar la cuenta «{name}» de tus otras cuentas?',
    removed: 'Cuenta eliminada',
    switched: 'Cuenta activa: {name}',
    switchError: 'Error al cambiar de cuenta',
    modalTitle: 'Añadir una cuenta {kind}',
    step1Hint: 'Inicia sesión con las credenciales de la cuenta {kind} que quieres vincular. Se enviará un código de confirmación a su email.',
    email: 'Email',
    password: 'Contraseña',
    captchaLabel: 'Cálculo anti-robot:',
    captchaHint: '= ?',
    sendCode: 'Enviar código',
    codeSent: 'Código enviado a {email}',
    otpHint: 'Se envió un código de 6 dígitos a {email}. Introdúcelo para confirmar el vínculo.',
    codeLabel: 'Código de 6 dígitos',
    linkBtn: 'Vincular cuenta',
    back: '← Volver al paso anterior',
    ok: '¡Cuenta vinculada con éxito!',
    footNote: 'Cada vínculo exige las credenciales de la cuenta objetivo + un código por email. Puedes quitar una cuenta vinculada en cualquier momento.',
    close: 'Cerrar',
  },
  ar: {
    title: 'حساباتي الأخرى',
    empty: 'ليس لديك حسابات مرتبطة أخرى. يمكنك ربط حساب {kind} واحد للتبديل بينهما.',
    addBtn: 'إضافة حساب {kind}',
    switching: 'جارٍ التحميل…',
    loading: 'جارٍ التحميل…',
    removeConfirm: 'إزالة الحساب "{name}" من حساباتك الأخرى؟',
    removed: 'تمت إزالة الحساب',
    switched: 'الحساب النشط: {name}',
    switchError: 'خطأ أثناء تبديل الحساب',
    modalTitle: 'إضافة حساب {kind}',
    step1Hint: 'سجّل الدخول ببيانات حساب {kind} الذي تريد ربطه. سيتم إرسال رمز تأكيد إلى بريده الإلكتروني.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    captchaLabel: 'التحقق ضد الروبوت:',
    captchaHint: '= ?',
    sendCode: 'إرسال الرمز',
    codeSent: 'تم إرسال الرمز إلى {email}',
    otpHint: 'تم إرسال رمز مكون من 6 أرقام إلى {email}. أدخله لتأكيد الربط.',
    codeLabel: 'رمز من 6 أرقام',
    linkBtn: 'ربط الحساب',
    back: '← العودة إلى الخطوة السابقة',
    ok: 'تم ربط الحساب بنجاح!',
    footNote: 'كل عملية ربط تتطلب بيانات الحساب الهدف + رمز عبر البريد. يمكنك إزالة الحساب المرتبط في أي وقت.',
    close: 'إغلاق',
  },
  pt: {
    title: 'Minhas outras contas',
    empty: 'Você não tem outra conta vinculada. Você pode vincular UMA conta {kind} para alternar entre elas.',
    addBtn: 'Adicionar uma conta {kind}',
    switching: 'Carregando…',
    loading: 'Carregando…',
    removeConfirm: 'Remover a conta "{name}" das suas outras contas?',
    removed: 'Conta removida',
    switched: 'Conta ativa: {name}',
    switchError: 'Erro ao trocar de conta',
    modalTitle: 'Adicionar uma conta {kind}',
    step1Hint: 'Entre com as credenciais da conta {kind} que você quer vincular. Um código de confirmação será enviado ao email dela.',
    email: 'Email',
    password: 'Senha',
    captchaLabel: 'Verificação anti-robô:',
    captchaHint: '= ?',
    sendCode: 'Enviar código',
    codeSent: 'Código enviado para {email}',
    otpHint: 'Um código de 6 dígitos foi enviado para {email}. Digite-o para confirmar a vinculação.',
    codeLabel: 'Código de 6 dígitos',
    linkBtn: 'Vincular conta',
    back: '← Voltar à etapa anterior',
    ok: 'Conta vinculada com sucesso!',
    footNote: 'Cada vínculo exige as credenciais da conta alvo + um código por email. Você pode remover uma conta vinculada a qualquer momento.',
    close: 'Fechar',
  },
  de: {
    title: 'Meine anderen Konten',
    empty: 'Du hast kein anderes verknüpftes Konto. Du kannst EIN {kind}-Konto verknüpfen, um dazwischen zu wechseln.',
    addBtn: '{kind}-Konto hinzufügen',
    switching: 'Lädt…',
    loading: 'Lädt…',
    removeConfirm: 'Konto „{name}" aus deinen anderen Konten entfernen?',
    removed: 'Konto entfernt',
    switched: 'Aktives Konto: {name}',
    switchError: 'Fehler beim Kontowechsel',
    modalTitle: '{kind}-Konto hinzufügen',
    step1Hint: 'Melde dich mit den Zugangsdaten des zu verknüpfenden {kind}-Kontos an. Ein Bestätigungscode wird an dessen E-Mail-Adresse gesendet.',
    email: 'E-Mail',
    password: 'Passwort',
    captchaLabel: 'Anti-Roboter-Check:',
    captchaHint: '= ?',
    sendCode: 'Code senden',
    codeSent: 'Code an {email} gesendet',
    otpHint: 'Ein 6-stelliger Code wurde an {email} gesendet. Gib ihn ein, um die Verknüpfung zu bestätigen.',
    codeLabel: '6-stelliger Code',
    linkBtn: 'Konto verknüpfen',
    back: '← Zurück',
    ok: 'Konto erfolgreich verknüpft!',
    footNote: 'Jede Verknüpfung erfordert die Zugangsdaten des Zielkontos + einen per E-Mail versendeten Code. Du kannst ein verknüpftes Konto jederzeit entfernen.',
    close: 'Schließen',
  },
  ru: {
    title: 'Мои другие аккаунты',
    empty: 'У вас нет других связанных аккаунтов. Можно связать ОДИН аккаунт {kind}, чтобы переключаться между ними.',
    addBtn: 'Добавить аккаунт {kind}',
    switching: 'Загрузка…',
    loading: 'Загрузка…',
    removeConfirm: 'Удалить аккаунт «{name}» из ваших других аккаунтов?',
    removed: 'Аккаунт удалён',
    switched: 'Активный аккаунт: {name}',
    switchError: 'Ошибка при смене аккаунта',
    modalTitle: 'Добавить аккаунт {kind}',
    step1Hint: 'Войдите с учётными данными связываемого аккаунта {kind}. Код подтверждения будет отправлен на его email.',
    email: 'Email',
    password: 'Пароль',
    captchaLabel: 'Антибот-проверка:',
    captchaHint: '= ?',
    sendCode: 'Отправить код',
    codeSent: 'Код отправлен на {email}',
    otpHint: '6-значный код отправлен на {email}. Введите его, чтобы подтвердить связь.',
    codeLabel: '6-значный код',
    linkBtn: 'Связать аккаунт',
    back: '← Назад',
    ok: 'Аккаунт успешно связан!',
    footNote: 'Каждая связь требует учётные данные целевого аккаунта + код по email. Вы можете отсоединить связанный аккаунт в любое время.',
    close: 'Закрыть',
  },
  zh: {
    title: '我的其他账户',
    empty: '你还没有其他关联账户。你可以关联一个 {kind} 账户以便在它们之间切换。',
    addBtn: '添加一个 {kind} 账户',
    switching: '加载中…',
    loading: '加载中…',
    removeConfirm: '要从其他账户中移除 "{name}" 吗？',
    removed: '账户已移除',
    switched: '当前账户：{name}',
    switchError: '切换账户时出错',
    modalTitle: '添加一个 {kind} 账户',
    step1Hint: '使用要关联的 {kind} 账户的凭证登录。确认码将发送到该账户的邮箱。',
    email: '邮箱',
    password: '密码',
    captchaLabel: '防机器人验证：',
    captchaHint: '= ?',
    sendCode: '发送验证码',
    codeSent: '验证码已发送至 {email}',
    otpHint: '一个 6 位数验证码已发送到 {email}。输入以确认关联。',
    codeLabel: '6 位验证码',
    linkBtn: '关联账户',
    back: '← 返回上一步',
    ok: '账户关联成功！',
    footNote: '每次关联都需要目标账户的凭证 + 通过邮件发送的验证码。你可以随时移除已关联的账户。',
    close: '关闭',
  },
  ja: {
    title: '他のアカウント',
    empty: '他のリンク済みアカウントはありません。1 つの {kind} アカウントをリンクして切り替えができます。',
    addBtn: '{kind} アカウントを追加',
    switching: '読み込み中…',
    loading: '読み込み中…',
    removeConfirm: '「{name}」を他のアカウントから外しますか？',
    removed: 'アカウントを外しました',
    switched: '現在のアカウント：{name}',
    switchError: 'アカウント切替でエラーが発生',
    modalTitle: '{kind} アカウントを追加',
    step1Hint: 'リンクしたい {kind} アカウントの資格情報でログインしてください。確認コードがそのメールアドレスに送信されます。',
    email: 'メール',
    password: 'パスワード',
    captchaLabel: 'ロボット検証：',
    captchaHint: '= ?',
    sendCode: 'コードを送信',
    codeSent: '{email} にコードを送信しました',
    otpHint: '6 桁のコードが {email} に送信されました。入力してリンクを確定してください。',
    codeLabel: '6 桁のコード',
    linkBtn: 'アカウントをリンク',
    back: '← 前のステップに戻る',
    ok: 'アカウントを正常にリンクしました！',
    footNote: 'リンクごとに対象アカウントの資格情報 + メールで送信されるコードが必要です。いつでも解除できます。',
    close: '閉じる',
  },
  hi: {
    title: 'मेरे अन्य खाते',
    empty: 'आपके पास कोई अन्य लिंक किया गया खाता नहीं है। आप एक {kind} खाता लिंक करके उनके बीच स्विच कर सकते हैं।',
    addBtn: '{kind} खाता जोड़ें',
    switching: 'लोड हो रहा…',
    loading: 'लोड हो रहा…',
    removeConfirm: 'खाता "{name}" को अन्य खातों से हटाएँ?',
    removed: 'खाता हटाया गया',
    switched: 'सक्रिय खाता: {name}',
    switchError: 'खाता बदलते समय त्रुटि',
    modalTitle: '{kind} खाता जोड़ें',
    step1Hint: 'जिस {kind} खाते को आप लिंक करना चाहते हैं उसके क्रेडेंशियल्स से साइन इन करें। पुष्टिकरण कोड उसकी ईमेल पर भेजा जाएगा।',
    email: 'ईमेल',
    password: 'पासवर्ड',
    captchaLabel: 'एंटी-रोबोट जाँच:',
    captchaHint: '= ?',
    sendCode: 'कोड भेजें',
    codeSent: '{email} पर कोड भेज दिया',
    otpHint: '6-अंकीय कोड {email} पर भेजा गया। लिंक की पुष्टि के लिए दर्ज करें।',
    codeLabel: '6-अंकीय कोड',
    linkBtn: 'खाता लिंक करें',
    back: '← पिछले चरण पर वापस',
    ok: 'खाता सफलतापूर्वक लिंक हुआ!',
    footNote: 'हर लिंक के लिए लक्ष्य खाते के क्रेडेंशियल्स + ईमेल से भेजा गया कोड आवश्यक है। आप किसी भी समय हटा सकते हैं।',
    close: 'बंद करें',
  },
  nl: {
    title: 'Mijn andere accounts',
    empty: 'Je hebt geen ander gekoppeld account. Je kunt EEN {kind}-account koppelen om ertussen te wisselen.',
    addBtn: '{kind}-account toevoegen',
    switching: 'Laden…',
    loading: 'Laden…',
    removeConfirm: 'Account "{name}" verwijderen uit je andere accounts?',
    removed: 'Account verwijderd',
    switched: 'Actief account: {name}',
    switchError: 'Fout bij accountwissel',
    modalTitle: '{kind}-account toevoegen',
    step1Hint: 'Meld je aan met de gegevens van het {kind}-account dat je wilt koppelen. Een bevestigingscode wordt naar zijn e-mail gestuurd.',
    email: 'E-mail',
    password: 'Wachtwoord',
    captchaLabel: 'Antibot-check:',
    captchaHint: '= ?',
    sendCode: 'Code sturen',
    codeSent: 'Code verstuurd naar {email}',
    otpHint: 'Een code van 6 cijfers is verstuurd naar {email}. Voer deze in om de koppeling te bevestigen.',
    codeLabel: '6-cijferige code',
    linkBtn: 'Account koppelen',
    back: '← Terug',
    ok: 'Account gekoppeld!',
    footNote: 'Elke koppeling vereist de inloggegevens van het doelaccount + een code per e-mail. Je kunt altijd loskoppelen.',
    close: 'Sluiten',
  },
  sw: {
    title: 'Akaunti zangu nyingine',
    empty: 'Huna akaunti nyingine iliyounganishwa. Unaweza kuunganisha akaunti MOJA ya {kind} kubadilisha kati yao.',
    addBtn: 'Ongeza akaunti ya {kind}',
    switching: 'Inapakia…',
    loading: 'Inapakia…',
    removeConfirm: 'Ondoa akaunti "{name}" kutoka akaunti zako nyingine?',
    removed: 'Akaunti imeondolewa',
    switched: 'Akaunti hai: {name}',
    switchError: 'Hitilafu wakati wa kubadilisha akaunti',
    modalTitle: 'Ongeza akaunti ya {kind}',
    step1Hint: 'Ingia kwa vitambulisho vya akaunti ya {kind} unayotaka kuunganisha. Msimbo wa uthibitisho utatumwa kwenye barua pepe yake.',
    email: 'Barua pepe',
    password: 'Nywila',
    captchaLabel: 'Ukaguzi wa kuzuia roboti:',
    captchaHint: '= ?',
    sendCode: 'Tuma msimbo',
    codeSent: 'Msimbo umetumwa kwa {email}',
    otpHint: 'Msimbo wa nambari 6 umetumwa kwa {email}. Ingiza kuthibitisha kiunga.',
    codeLabel: 'Msimbo wa nambari 6',
    linkBtn: 'Unganisha akaunti',
    back: '← Rudi hatua ya awali',
    ok: 'Akaunti imeunganishwa kwa mafanikio!',
    footNote: 'Kila kiunganishaji kinahitaji vitambulisho vya akaunti lengwa + msimbo kupitia barua pepe. Unaweza kuondoa wakati wowote.',
    close: 'Funga',
  },
  ht: {
    title: 'Lòt kont mwen yo',
    empty: 'Ou pa gen okenn lòt kont ki lye. Ou ka lye YON kont {kind} pou chanje ant yo.',
    addBtn: 'Ajoute yon kont {kind}',
    switching: 'K ap chaje…',
    loading: 'K ap chaje…',
    removeConfirm: 'Retire kont "{name}" nan lòt kont ou yo ?',
    removed: 'Kont retire',
    switched: 'Kont aktif : {name}',
    switchError: 'Erè pandan chanjman kont',
    modalTitle: 'Ajoute yon kont {kind}',
    step1Hint: 'Konekte ak enfòmasyon idantifikasyon kont {kind} ou vle lye a. Yon kòd konfimasyon ap voye nan imèl li.',
    email: 'Imèl',
    password: 'Modpas',
    captchaLabel: 'Verifikasyon anti-wobo :',
    captchaHint: '= ?',
    sendCode: 'Voye kòd la',
    codeSent: 'Kòd voye nan {email}',
    otpHint: "Yon kòd 6 chif voye nan {email}. Antre l pou konfime lyezon an.",
    codeLabel: 'Kòd 6 chif',
    linkBtn: 'Lye kont la',
    back: '← Retounen',
    ok: 'Kont lye avèk siksè !',
    footNote: 'Chak lyezon egzije enfòmasyon idantifikasyon kont sib + yon kòd voye pa imèl. Ou ka retire yon kont lye nenpòt kilè.',
    close: 'Fèmen',
  },
};

export const useLinkedT = () => {
  const { language } = useLanguage();
  return (key, vars) => {
    let v = linkedAccountsI18n[language]?.[key];
    if (v == null) v = linkedAccountsI18n.en[key];
    if (typeof v !== 'string') return key;
    if (vars) {
      return v.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
    }
    return v;
  };
};

export default linkedAccountsI18n;
